import React, { useState, useEffect } from 'react';

import { get } from '../services/api';
import Loading from './Loading/Loading';
import PowerfulTable from './PowerfulTable/PowerfulTable';

const PupilsList = (props) => {

  const [pupils, setPupils] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchPupils = async () => {
      // Helper to deduplicate by _id
      const dedup = (list) => {
        const seen = new Set();
        return list.filter(item => {
          if (seen.has(item._id)) return false;
          seen.add(item._id);
          return true;
        });
      };

      // 1. Initial load for speed
      const initialPupils = await get('/admin/pupils?limit=50');
      if (isMounted) {
        setPupils(dedup(initialPupils || []));
      }

      // 2. Background load for completeness
      get('/admin/pupils?limit=10000&skip=50').then(rest => {
        if (isMounted && rest && rest.length > 0) {
          setPupils(prev => {
            return dedup([...prev, ...rest]);
          });
        }
      });
    };

    fetchPupils();

    return () => { isMounted = false; };
  }, [props.pupils]);

  if (!pupils?.length) return <Loading />

  return (
    <div style={{ marginLeft: 20, width: '100%', height: '100%' }}>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>Elèves ({pupils.length})</h2>
      </div>

      <PowerfulTable
        data={pupils}
        types={{
          _id: { name: 'email' },
          firstname: { name: 'prénom' },
          lastname: { name: 'nom' },
          contacted: { name: 'Contacté' },
          number: { name: 'téléphone' },
          zipcode: { name: 'code postal' },
          signup: { name: 'inscription' },
          subscription: { name: 'abonnement' },
          pass: { name: 'pass (fin)' },
        }}
        redirect={'pupils'}
        redirectKey={'_id'}
      />
    </div>
  );
};

export default PupilsList;
